import { Button, Box } from '@mui/material'
import { MAX_MUTLTI_EDIT_DOCS } from 'config'
import { DocListItem } from 'entities/Documents'
import { useAlert } from 'hooks/useDialog'
import useEditDocuments from 'hooks/useEditDocuments'
import { useMemo } from 'react'

type Props = {
  documents: DocListItem[] | null
  selectedIDs: string[]
  setOpenDelDialog: (x: boolean) => void
  setOpenUploadDialog: (x: boolean) => void
}

const mode = 'verify'

function ControlArea({ documents, selectedIDs, setOpenDelDialog, setOpenUploadDialog }: Props) {
  const alert = useAlert()
  const editDocuments = useEditDocuments()
  const disabled = selectedIDs.length === 0
  const maxMultiEdit = selectedIDs.length > MAX_MUTLTI_EDIT_DOCS

  const selectedDocs = useMemo(() => {
    if (selectedIDs.length === 0) return []
    return (documents || []).filter((doc) => selectedIDs.includes(doc.objectID))
  }, [selectedIDs, documents])

  const selectedTypes = useMemo(() => {
    return [...new Set(selectedDocs.map(({ documentTypeName }) => documentTypeName))]
  }, [selectedDocs])

  const multiTypesSelected = selectedTypes.length > 1

  const handleDeleteButtonClick = () => {
    setOpenDelDialog(true)
  }

  const handleEditButtonClick = () => {
    if (multiTypesSelected) {
      return alert({ message: '異なる文書タイプを同時に編集はできません' })
    }
    editDocuments(
      mode,
      selectedDocs.map(({ objectID }) => objectID),
      true,
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      <Box>
        <Button
          onClick={() => setOpenUploadDialog(true)}
          variant="outlined"
          color="primary"
          data-testid="home-control-register-button"
        >
          新規登録
        </Button>
      </Box>
      <Box>
        <Button
          variant="outlined"
          color="primary"
          disabled={disabled || maxMultiEdit}
          onClick={handleEditButtonClick}
          data-testid="home-control-edit-button"
        >
          編集
        </Button>
        <Button
          onClick={handleDeleteButtonClick}
          variant="contained"
          color="secondary"
          disabled={disabled}
          data-testid="home-control-delete-button"
        >
          削除
        </Button>
      </Box>
    </Box>
  )
}

export default ControlArea
